module.exports = __webpack_public_path__ + "static/media/Online_life_is_real_life_Parents_EN.35ffe7f9.pdf";